/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

/*
 * Performance: este arquivo era o unico consumidor de jQuery no tema depois que
 * CU_script.js saiu do ar. Reescrito em JS puro, o que permitiu remover o
 * jquery.min.js (89 KB) do carregamento de TODAS as paginas da loja.
 * O comportamento e identico ao da versao com jQuery.
 */

(function () {
  // Add custom code below this line

  // Helpers que substituem o acucar sintatico do jQuery.
  var qs = function (selector, scope) {
    return (scope || document).querySelector(selector);
  };

  var qsa = function (selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  };

  var setHTML = function (selector, html) {
    qsa(selector).forEach(function (el) {
      el.innerHTML = html;
    });
  };

  // Equivalente ao .show().html() do jQuery: .shipping-estimate .result nasce
  // com display:none no theme.css, entao o jQuery aplicava display:block inline.
  var showHTML = function (selector, html) {
    qsa(selector).forEach(function (el) {
      el.style.display = "block";
      el.innerHTML = html;
    });
  };

  var body = qs("body.template-product");
  if (body) {
    var states = {
      AC: "Acre",
      AL: "Alagoas",
      AP: "Amapá",
      AM: "Amazonas",
      BA: "Bahia",
      CE: "Ceará",
      DF: "Distrito Federal",
      ES: "Espírito Santo",
      GO: "Goiás",
      MA: "Maranhão",
      MT: "Mato Grosso",
      MS: "Mato Grosso do Sul",
      MG: "Minas Gerais",
      PA: "Pará",
      PB: "Paraíba",
      PR: "Paraná",
      PE: "Pernambuco",
      PI: "Piauí",
      RJ: "Rio de Janeiro",
      RN: "Rio Grande do Norte",
      RS: "Rio Grande do Sul",
      RO: "Rondônia",
      RR: "Roraima",
      SC: "Santa Catarina",
      SP: "São Paulo",
      SE: "Sergipe",
      TO: "Tocantins",
    };

    // Validade do cache de taxas por CEP + variante (5 minutos).
    var RATE_CACHE_TTL = 5 * 60 * 1000;

    async function getCepData(cep) {
      const response = await fetch(
        "https://viacep.com.br/ws/" + cep + "/json/"
      );
      const data = await response.json();
      return data;
    }

    var showRates = function (rates, city, state, target) {
      var output = "";
      if (rates === false) {
        if (target == "product") {
          calcError(
            "Nenhum método de entrega encontrado, confira se o CEP informado é válido."
          );
        }
      } else {
        var truck_icon =
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 21.5" aria-hidden="true" focusable="false"><g data-name="Layer 2"><g data-name="Layer 1"><path d="M7.16 17H6a1 1 0 0 1-1-1v-4a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h1.2a3.48 3.48 0 0 0 6.68 0h6.32a3.48 3.48 0 0 0 6.68 0H29a1 1 0 0 0 1-1v-5a4.91 4.91 0 0 0-.72-2.39l-2.9-4.33A3.08 3.08 0 0 0 24 5h-2.8V3a3 3 0 0 0-3-3H15a1 1 0 0 0 0 2h3.2a1 1 0 0 1 1 1v14h-5.36a3.48 3.48 0 0 0-6.68 0Zm16.34 2.5A1.5 1.5 0 1 1 25 18a1.5 1.5 0 0 1-1.5 1.5ZM21.2 7H24a1.08 1.08 0 0 1 .72.39L26.47 10H21.2Zm0 5h6.56a3.14 3.14 0 0 1 .24 1v4h-1.16a3.47 3.47 0 0 0-4.31-2.35 3.43 3.43 0 0 0-1.33.74ZM12 18a1.5 1.5 0 1 1-1.5-1.5A1.5 1.5 0 0 1 12 18Z"/><path d="M13 1a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h11a1 1 0 0 0 1-1Zm-3 5a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2Zm-2 4a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2Z"/></g></g></svg>';
        output +=
          '<div class="heading">' +
          truck_icon +
          " Opções de Frete para " +
          city +
          " - " +
          state +
          "</div>";
        output += '<div class="shipping-rates">';
        output += '<div class="rates">';
        Object.keys(rates).forEach((key) => {
          var rate = rates[key];
          var price = parseFloat(rate.price);
          var delivery = "";

          if (price == 0.0) {
            price = "<b>Grátis</b>";
          } else {
            price = price.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            });
          }

          delivery =
            '<div class="rate__info"><span><b>' +
            rate.presentment_name.replace(" (via Shippy)", "") +
            ": </b></span><span><b>" +
            price +
            "</b> Produção + <b>" +
            rate.delivery_days[0] +
            "</b> dias úteis</span></div>";

          output += '<div class="rate">';
          output += delivery;
          output += "</div>";
        });

        output += "</div>";
        output +=
          '<p class="result__information">* O prazo de Produção deste produto é especificado abaixo.</p>';

        output += "</div>";

        if (target == "product") {
          showHTML(".shipping-estimate .result", output);
        }
      }
    };

    var getCookie = function (name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    };

    var cartCookie = getCookie("cart");

    var updateCartCookie = function (a) {
      var date = new Date();
      date.setTime(date.getTime() + 14 * 86400000);
      var expires = "; expires=" + date.toUTCString();
      document.cookie = "cart=" + a + expires + "; path=/";
    };

    var resetCartCookie = function () {
      updateCartCookie(cartCookie);
      endLoader();
    };

    var startLoader = function (message = "") {
      var loader_icon =
        '<svg version="1.1" id="L5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style="display: inline-block;width: 30px;" aria-hidden="true" focusable="false"><circle fill="#111" stroke="none" cx="6" cy="50" r="6"><animateTransform attributeName="transform" dur="1s" type="translate" values="0 15 ; 0 -15; 0 15" repeatCount="indefinite" begin="0.1"></animateTransform></circle><circle fill="#111" stroke="none" cx="30" cy="50" r="6"><animateTransform attributeName="transform" dur="1s" type="translate" values="0 10 ; 0 -10; 0 10" repeatCount="indefinite" begin="0.2"></animateTransform></circle><circle fill="#111" stroke="none" cx="54" cy="50" r="6"><animateTransform attributeName="transform" dur="1s" type="translate" values="0 5 ; 0 -5; 0 5" repeatCount="indefinite" begin="0.3"></animateTransform></circle></svg>';
      setHTML(".shipping-estimate .loading", loader_icon + message);
      setHTML(".shipping-estimate .result", "");
    };

    var endLoader = function () {
      setHTML(".shipping-estimate .loading", "");
    };

    var calcError = function (message) {
      setHTML(".shipping-estimate .loading", "");
      // O display:block e obrigatorio: .shipping-estimate .result nasce com
      // display:none no theme.css, entao sem isso a mensagem fica invisivel.
      showHTML(
        ".shipping-estimate .result",
        '<span class="error">' + message + "</span>"
      );
    };

    var calculateShipping = function () {
      var idInput = qs('input[name="id"]');
      var cepInput = qs(".cep-estimate");

      if (!cepInput) {
        return;
      }

      var product_id = idInput ? idInput.value : undefined;
      var cep = cepInput.value.replace(/\D/g, "");

      if (cep.length == 8) {
        startLoader("Calculando frete");

        getCepData(cep)
          .then((data) => {
            var country = "Brazil";
            var state = states[data.uf];
            var city = data.localidade;

            var zip = cep;
            var random = (Math.random() + 1).toString(36).substring(10);

            localStorage.setItem("cepCache", zip);

            startLoader("Calculando frete para " + city + " - " + state);

            cartCookie = getCookie("cart");

            var tempCookieValue =
              tempCookieValue || "temp-cart-cookie___" + Date.now() + random;
            var fakeCookieValue =
              fakeCookieValue || "fake-cart-cookie___" + Date.now() + random;

            if (!cartCookie) {
              updateCartCookie(tempCookieValue);
              cartCookie = getCookie("cart");
            }

            if (!cartCookie || cartCookie.length < 32) {
              calcError(
                "Não foi possível iniciar o cálculo do frete. Recarregue a página e tente novamente."
              );
              return;
            }

            updateCartCookie(fakeCookieValue);

            getRates(parseInt(product_id), country, state, city, zip);

            return;
          })
          .catch(function () {
            endLoader();
          });
      } else {
        calcError("Por favor, insira um CEP válido.");
      }
    };

    // Delegacao de evento em JS puro, equivalente ao $(document).on(...).
    // O guard de Element existe porque o alvo de um evento no document nem
    // sempre e um elemento (e ai closest nao existe).
    var closestFrom = function (node, selector) {
      return node instanceof Element ? node.closest(selector) : null;
    };

    document.addEventListener("click", function (e) {
      if (!closestFrom(e.target, ".shipping-estimate button")) {
        return;
      }

      e.preventDefault();
      calculateShipping();
    });

    // keydown no lugar do keypress do jQuery: keypress esta depreciado e as
    // duas versoes reagem igual ao Enter.
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Enter") {
        return;
      }

      if (!closestFrom(e.target, ".shipping-estimate .cep-estimate")) {
        return;
      }

      e.preventDefault();
      calculateShipping();
    });

    var getRates = function (variantId, country, state, city, zip) {
      if (typeof variantId === "undefined") {
        return;
      }

      var productQuantity = qs(".quantity__input");

      var quantity = productQuantity ? parseInt(productQuantity.value) : 1;

      if (!quantity || isNaN(quantity)) {
        quantity = 1;
      }

      var addData = {
        id: variantId,
        quantity: quantity,
      };

      var ratesQuery = new URLSearchParams({
        "shipping_address[country]": country,
        "shipping_address[province]": state,
        "shipping_address[zip]": zip,
      });

      // Consulta as taxas com fetch, e não com $.ajax: apps de pixel instalados
      // na loja sobrescrevem XMLHttpRequest.prototype.send e essa versão
      // sobrescrita estoura TypeError, abortando qualquer chamada jQuery.ajax
      // antes de sair do navegador. fetch não passa por esse patch.
      var fetchRates = function (attempt) {
        return fetch("/cart/shipping_rates.json?" + ratesQuery.toString(), {
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error("shipping_rates.json: HTTP " + response.status);
            }

            return response.json();
          })
          .then(function (d) {
            var rates = d && d.shipping_rates ? d.shipping_rates : [];

            // A transportadora (Frenet) às vezes responde vazio na primeira
            // consulta. Só a consulta é repetida — nunca o /cart/add.js, senão
            // o produto entraria várias vezes no carrinho temporário.
            if (!rates.length && attempt < 3) {
              return new Promise(function (resolve) {
                setTimeout(resolve, 800);
              }).then(function () {
                return fetchRates(attempt + 1);
              });
            }

            return rates;
          });
      };

      fetch("/cart/add.js", {
        body: JSON.stringify(addData),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
        method: "POST",
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("cart/add.js: HTTP " + response.status);
          }

          return response.json();
        })
        .then(function () {
          return fetchRates(0);
        })
        .then(function (rates) {
          if (rates.length) {
            localStorage.setItem(
              "cepCache_" + zip + "_" + variantId,
              JSON.stringify({
                rates: rates,
                city: city,
                state: state,
                expires: Date.now() + RATE_CACHE_TTL,
              })
            );
            showRates(rates, city, state, "product");
          } else {
            showRates(false, false, false, "product");
          }

          resetCartCookie();
        })
        .catch(function (err) {
          console.error("Erro ao calcular frete:", err);
          calcError(
            "Ocorreu um erro durante o calculo do frete, por favor, tente novamente."
          );
          resetCartCookie();
        });
    };

    var getCachedValues = function () {
      var idInput = qs('input[name="id"]');
      var pid = idInput ? idInput.value : undefined;
      var cepCache = localStorage.getItem("cepCache");

      if (cepCache != null) {
        qsa(".cep-estimate").forEach(function (input) {
          input.value = cepCache;
          input.dispatchEvent(new Event("input", { bubbles: true }));
        });

        var rateCache = localStorage.getItem(
          "cepCache_" + cepCache + "_" + pid
        );

        if (rateCache != null) {
          rateCache = JSON.parse(rateCache);
          // Só reexibe o cache enquanto ele ainda é válido. A comparação estava
          // invertida, então a loja mostrava justamente as taxas vencidas.
          if (Date.now() < rateCache["expires"]) {
            showRates(
              rateCache["rates"],
              rateCache["city"],
              rateCache["state"],
              "product"
            );
          } else {
            localStorage.removeItem("cepCache_" + cepCache + "_" + pid);
          }
        }
      }
    };

    getCachedValues();
  }

  // Traduz os rótulos de data do widget de avaliações do Google.
  // O widget e injetado por app, entao a traducao so pode acontecer depois que
  // ele terminar de renderizar.
  setTimeout(function () {
    var replacements = [
      ["days ago", "dias atrás"],
      ["last month", "mês passado"],
      ["months ago", "meses atrás"],
    ];

    qsa(
      ".meggnoapps_google_reviews_widget_carousel .review_widget_user_details .written_ago a span"
    ).forEach(function (el) {
      var text = el.textContent;

      replacements.forEach(function (pair) {
        if (text.indexOf(pair[0]) !== -1) {
          text = text.replace(pair[0], pair[1]);
        }
      });

      if (text !== el.textContent) {
        el.textContent = text;
      }
    });
  }, 12000);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
